import type { FC } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

import BackButton from 'components/BackButton';
import { StepProps } from 'components/Stepper/types';
import * as Layout from 'layouts/StickyStepperLayout';

import * as routes from '../../../../../../routes';
import {
  getMemberRoleTransitionPath,
  getMemberTabPath,
} from '../../../../../../routes';
import { useMemberInviteState } from '../../../MemberInviteProvider';
import MemberInformationForm from './MemberInformationForm';
import { MemberInformationFormSchema } from './MemberInformationForm/schema';

const MemberInformation: FC<StepProps> = ({ goBack, goNext }) => {
  const history = useHistory();

  const { dispatch, shouldShowLegalBeneficiarySelector } =
    useMemberInviteState();

  const cancelFlow = () => {
    history.push(routes.members);
  };

  const goBackToCanceledUsers = () => {
    history.push(getMemberTabPath('locked'));
  };

  const handleBackButtonClick = () => {
    if (shouldShowLegalBeneficiarySelector) {
      goBack();
    } else {
      cancelFlow();
    }
  };

  const handleEditUserClick = (companyUserId: string) => {
    history.push(getMemberRoleTransitionPath(companyUserId));
  };

  const handleSubmit: SubmitHandler<MemberInformationFormSchema> = async (
    data,
  ) => {
    dispatch({
      payload: data,
      type: 'SUBMIT_INVITE_INFORMATION',
    });

    goNext();
  };

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton onClick={handleBackButtonClick} />
        </Layout.HeaderButtonsContainer>
        <MemberInformationForm
          handleCancel={cancelFlow}
          onBackToLockedUsers={goBackToCanceledUsers}
          onEditExistingUser={handleEditUserClick}
          onRevokedMembersEditClicked={handleEditUserClick}
          onSubmit={handleSubmit}
        />
      </Layout.Body>
    </Layout.Root>
  );
};

export default MemberInformation;
